"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSortFields = exports.flipSort = exports.flipDirection = exports.sortRecords = exports.naturalSort = void 0;
const fast_sort_1 = require("fast-sort");
const number_1 = require("../helpers/number");
const fields_1 = require("../utils/fields");
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
const numberComparer = (a, b, order) => {
    // default function that used fast-sort lib for sort function
    if (a == null)
        return order;
    if (b == null)
        return -order;
    if (a < b)
        return -1;
    if (a === b)
        return 0;
    return 1;
};
exports.naturalSort = (0, fast_sort_1.createNewSortInstance)({
    comparer: (a, b, order) => {
        // For numbers use default comparer
        // Intl.Collator sorts negative values incorrectly
        if ((0, number_1.isNumber)(a) && (0, number_1.isNumber)(b)) {
            return numberComparer(a, b, order);
        }
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: "accent",
        });
        // For strings use Intl.Collator.compare function
        return collator.compare(a, b);
    },
});
/**
 * Search through records with text query in selected fields.
 * Each field value is converted to the string and checked
 * for match with the query
 */
function sortRecords(records = [], fields, sortRules = [], userPreferences, groupByRules = [], reportId) {
    const rules = [
        ...groupByRules.map((rule) => ({ ...rule, isGroupByRule: true })),
        ...sortRules.map((rule) => ({ ...rule, isGroupByRule: false })),
    ];
    if (!rules.length && !reportId) {
        return records;
    }
    // Cache for getKey function results
    const keyCache = new Map();
    const valueGetters = rules.map((rule) => {
        var _a;
        const field = (0, fields_1.getAppFieldBySlug)(fields, rule.field);
        const currentField = (_a = field === null || field === void 0 ? void 0 : field.parent) !== null && _a !== void 0 ? _a : field;
        if (!currentField) {
            return {
                asc: () => { },
            };
        }
        const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(currentField.field_type);
        const comparer = (record) => {
            const fieldValue = (0, fields_1.getValueFromRecordByField)(record, currentField);
            const cacheKey = fieldLogic.getSortCacheKey(currentField, fieldValue, rule, rule.isGroupByRule);
            if (cacheKey !== undefined && keyCache.has(cacheKey)) {
                return keyCache.get(cacheKey);
            }
            // If not cached, compute and cache the result
            const result = getKey(fieldValue, currentField, fieldLogic, record, fields, rule, userPreferences);
            if (cacheKey !== undefined) {
                keyCache.set(cacheKey, result);
            }
            return result;
        };
        return rule.direction === "asc" ? { asc: comparer } : { desc: comparer };
    });
    if (reportId) {
        valueGetters.push({
            asc: (record) => {
                const ranking = record.ranking;
                if (ranking) {
                    return ranking[reportId] || ranking.default;
                }
                return "aaaaaaaaaa";
            },
        });
    }
    return (0, exports.naturalSort)(records).by(valueGetters);
}
exports.sortRecords = sortRecords;
function getKey(fieldValue, currentField, fieldLogic, record, fields, rule, userPreferences) {
    if (rule.isGroupByRule) {
        return fieldLogic.groupBySortKey(fieldValue, currentField, userPreferences, record, fields, rule);
    }
    return fieldLogic.sortKey(fieldValue, currentField, userPreferences, record, fields, rule);
}
/**
 * Flip sort direction to the opposite.
 */
function flipDirection(direction) {
    return direction === "asc" ? "desc" : "asc";
}
exports.flipDirection = flipDirection;
/**
 * Flip sort direction to the opposite, keeping the same field.
 */
function flipSort(sort) {
    return { ...sort, direction: flipDirection(sort.direction) };
}
exports.flipSort = flipSort;
function getSortFields(rules) {
    return rules.map((rule) => rule.field);
}
exports.getSortFields = getSortFields;
